import {
  doc,
  getDoc,
  getDocs,
  collection,
  query,
  limit,
  addDoc,
  updateDoc,
  deleteDoc,
  startAfter,
  getCountFromServer,
  orderBy,
  where,
} from "firebase/firestore";
import { db } from "config/firebase";

const getDocument = (id) => {
  return doc(db, "predictions", id);
};

export const getData = async (reference) => {
  if (reference) {
    const docSnap = await getDoc(reference);
    return docSnap.exists() ? { id: docSnap?.id, ...docSnap.data() } : null;
  }
  return null;
};

export const getPredictions = async (last, limitCount = 50) => {
  try {
    // Query to get the predictions
    const q = last
      ? query(
          collection(db, "predictions"),
          orderBy("createdAt", "desc"),
          startAfter(last),
          limit(limitCount),
        )
      : query(
          collection(db, "predictions"),
          orderBy("createdAt", "desc"),
          limit(limitCount),
        );

    const documentSnapshots = await getDocs(q);

    // Get the last visible document
    const lastVisible =
      documentSnapshots.docs[documentSnapshots.docs.length - 1];

    const predictions = documentSnapshots.docs.map((doc) => {
      return { ...doc.data(), id: doc.id };
    });

    let totalPredictionsCount = predictions.length;
    let counts = null;

    if (!last) {
      try {
        const [countSnapshot, finishedSnapshot, pendingSnapshot] =
          await Promise.all([
            getCountFromServer(query(collection(db, "predictions"))),
            getCountFromServer(
              query(
                collection(db, "predictions"),
                where("type", "==", "finished")
              )
            ),
            getCountFromServer(
              query(
                collection(db, "predictions"),
                where("type", "==", "pending")
              )
            ),
          ]);
        totalPredictionsCount = countSnapshot.data().count;
        const finished = finishedSnapshot.data().count;
        const pending = pendingSnapshot.data().count;
        const active = Math.max(0, totalPredictionsCount - finished - pending);
        counts = {
          total: totalPredictionsCount,
          finished,
          pending,
          active,
        };
      } catch (countErr) {
        console.warn("Failed to get count breakdown, using fallback", countErr);
        const countQuery = query(collection(db, "predictions"));
        const countSnapshot = await getCountFromServer(countQuery);
        totalPredictionsCount = countSnapshot.data().count;
        counts = {
          total: totalPredictionsCount,
          finished: 0,
          pending: 0,
          active: totalPredictionsCount,
        };
      }
    }

    return { predictions, last: lastVisible, totalPredictionsCount, counts };
  } catch (error) {
    console.error(`Error while getting predictions: ${error}`);
    return error;
  }
};

export const getPredictionsLength = async () => {
  const countQuery = query(collection(db, "predictions"));
  const countSnapshot = await getCountFromServer(countQuery);
  const totalPredictionsCount = countSnapshot.data().count;
  return totalPredictionsCount;
};

export const getPredictionById = async (id) => {
  const docRef = getDocument(id);
  const docSnap = await getDoc(docRef);
  const lesson = docSnap.data();
  return docSnap.exists() ? { id: docSnap.id, ...lesson, reviewers: [] } : null;
};

export const createPrediction = async (prediction) => {
  try {
    const newPrediction = await addDoc(
      collection(db, "predictions"),
      prediction,
    );
    return newPrediction;
  } catch (e) {
    console.error(`Error while creating prediction ${e}`);
    return false;
  }
};

export const updatePredictions = async (id, data) => {
  try {
    await updateDoc(getDocument(id), data);
  } catch (e) {
    console.error(`Error while updating prediction ${e}`);
    return false;
  }
};

export const deletePrediction = async (id) => {
  try {
    await deleteDoc(getDocument(id));
  } catch (e) {
    console.error(`Error while deleting prediction ${e}`);
    return false;
  }
};
